import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return createStyles({
        active: {
            background: 'var(--secundario-gris-azulado) !important',
            color: 'var(--text1) !important',
            fontWeight: 700,
        },
    });
});
export default useStyles;
